export default {
	THANKS: 'Спасибо',
	OK: 'Окей',
	YES: 'Да',
	NO: 'Нет',
	ERROR: 'Ошибка',
	SUCCESS: 'Успешно',
	SEARCH: 'Поиск',

	INN: 'ИНН',
	KPP: 'КПП'
};